import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import ActiveVendors from './ActiveVendors'
import InActiveVendors from './InActiveVendors'
import ViewServiceReq from '../leads/ViewServiceReq'
import HospitalPreview from '../leads/HospitalPreview'
import CompanyPreview from '../leads/CompanyPreview'
import EventPreview from '../leads/EventPreview'
import EditHospitalProfile from '../leads/EditHospitalProfile'
import EditCompany from '../leads/EditCompany'
import EditEvent from '../leads/EditEvent'
import ViewPaymentDetails from './ViewPaymentDetails'
import ServiceDetails from './ServiceDetails'
import ViewDetails from './ViewDetails'

function VendorMudule() {
  return (
    <div>
    <Suspense fallback={null}>
      <Routes>
        <Route path="activeVendor" element={<ActiveVendors />} />
        <Route path="inActiveVendor" element={<InActiveVendors />} />
        <Route path="inActiveVendor/ViewDetails" element={<ViewDetails />} />
        <Route path="activeVendor/ViewDetails" element={<ViewDetails />} />
        <Route path="inActiveVendor/viewServiceReq" element={<ViewServiceReq />} />
        <Route path="inActiveVendor/previewHospital" element={<HospitalPreview />} />
        <Route path="inActiveVendor/previewCompany" element={<CompanyPreview />} />
        <Route path="inActiveVendor/eventPreview" element={<EventPreview />} />
        <Route path="inActiveVendor/editHospitals" element={<EditHospitalProfile />} />
        <Route path="inActiveVendor/editCompany" element={<EditCompany />} />
        <Route path="inActiveVendor/editEvent" element={<EditEvent />} />
        <Route path="inActiveVendor/serviceDetails" element={<ServiceDetails />} />
        <Route path="activeVendor/viewServiceReq" element={<ViewServiceReq />} />
        <Route path="activeVendor/previewHospital" element={<HospitalPreview />} />
        <Route path="activeVendor/previewCompany" element={<CompanyPreview />} />
        <Route path="activeVendor/eventPreview" element={<EventPreview />} />
        <Route path="activeVendor/editHospitals" element={<EditHospitalProfile />} />
        <Route path="activeVendor/editCompany" element={<EditCompany />} />
        <Route path="activeVendor/editEvent" element={<EditEvent />} />
        <Route path="activeVendor/serviceDetails" element={<ServiceDetails />} />
        <Route path="activeVendor/viewPaymentsDetails" element={<ViewPaymentDetails />} />
        <Route path="inActiveVendor/viewPaymentsDetails" element={<ViewPaymentDetails />} />
        
      </Routes>
    </Suspense>
  </div>
  )
}

export default VendorMudule
